import React, { useContext } from "react";
import AppContext from "../../store/app-context";
import Closing from "../Closing/Closing";
import Form from "../Form/Form";
import Impression from "../Impression/Impression";
import InputForm from "../InputForm/InputForm";
import Question from "../Question/Question";
import styles from "./survey.module.css";

const Survey = () => {
  const appCtx = useContext(AppContext);
  const rand = Math.floor(Math.random() * 10);
  const bodyStyle =
    rand < 5 ? [styles.body, styles.left] : [styles.body, styles.right];
  const footerStyle =
    rand < 5 ? [styles.footer, styles.left] : [styles.footer, styles.right];

  return (
    <div className={styles.survey}>
      <div className={styles.header}>
        <div className={styles["header-logo"]}>
          <img src="/images/logo-sardana.png" alt="Logo" />
        </div>
      </div>
      <div className={bodyStyle.join(" ")}>
        <div className={styles.content}>
          {appCtx.step === 1 && <Impression />}
          {appCtx.step === 2 && <Form content={appCtx.content} />}
          {appCtx.step === 3 &&
            !appCtx.finish &&
            appCtx.category === "satisfy" && (
              <Question content={appCtx.content} />
            )}
          {appCtx.step === 3 &&
            !appCtx.finish &&
            appCtx.category === "complain" && <InputForm content="" />}
          {appCtx.step === 3 && !appCtx.finish && appCtx.category === "ask" && (
            <InputForm content={appCtx.content} />
          )}
          {appCtx.finish && <Closing content={appCtx.content} />}
        </div>
      </div>
      <div className={footerStyle.join(" ")}></div>
    </div>
  );
};

export default Survey;
